import React, { useState, useEffect, useRef, useMemo } from "react";
import { timeout } from "rxjs";


// http://kpomservices.com/reactjseditor/index.html

function Preview({ adors, curBoxSize, croppedImage, previewSettings }) {
  // const { editor, onReady } = useFabricJSEditor()
  const myCanvas = useRef(null);
  const [lastAdorImg, setLastAdorImg] = useState();

  // Drawing adors elements on to a canvas
  useEffect(() => {
    const ctx = myCanvas.current.getContext('2d');
    const bg = new Image();
    bg.src = `/sees/dist/img/products/${curBoxSize.product_id}.jpg`;
    bg.onload = () => { drawBgImage(bg, ctx); }

    if (croppedImage) {
      setTimeout(() => {
        const fg = new Image();
        fg.src = croppedImage;
        fg.onload = () => {
          drawAdorImage(fg, ctx);
        };
      }, 800);
    }

  }, [curBoxSize]);

  // Drawing adors elements on to a canvas
  useEffect(() => {
    const ctx = myCanvas.current.getContext('2d');
    if (croppedImage) {
      const fg = new Image();
      fg.src = croppedImage;
      fg.onload = () => {
        drawAdorImage(fg, ctx);
      };
    }
    else {
      const fg = new Image();
      fg.src = "/sees/dist/img/products/your_logo.jpg";
      fg.onload = () => { drawAdorImage(fg, ctx) };
    }
  }, [croppedImage]);

  const drawBgImage = (img, ctx) => {
    let canvas = ctx.canvas;
    let hRatio = canvas.width / img.width;
    let vRatio = canvas.height / img.height;
    let ratio = Math.min(hRatio, vRatio);
    let translate_x = (canvas.width - img.width * ratio) / 2;
    let translate_y = (canvas.height - img.height * ratio) / 2;
    // ctx.clearRect(0, 0, canvas.width, canvas.height);
    // For jpeg white background
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(img,
      0, 0, img.width, img.height,
      translate_x, translate_y, img.width * ratio, img.height * ratio);
  }

  // Using adors canvas to draw ador object
  const drawAdorImage = (img, ctx) => {
    let canvas = ctx.canvas;

    let hRatio = canvas.width / img.width / 1.2;
    let vRatio = canvas.height / img.height / 1.25;
    let ratio = Math.min(hRatio, vRatio);

    let translate_x = (canvas.width - img.width * ratio) / 2;
    let translate_y = (canvas.height - img.height * ratio) / 2;
    if (lastAdorImg) {
      // ctx.clearRect(lastAdorImg.x, lastAdorImg.y, lastAdorImg.w, lastAdorImg.h);
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(lastAdorImg.x -1, lastAdorImg.y -1, lastAdorImg.w + 2, lastAdorImg.h + 2);
    }
    ctx.drawImage(img,
      0, 0, img.width, img.height,
      translate_x, translate_y, img.width * ratio, img.height * ratio);

    setLastAdorImg({ x: translate_x, y: translate_y, w: img.width * ratio, h: img.height * ratio })
  }


  const canvasContent = () => {
    const canvas = document.getElementById('my-canvas');
    return canvas && canvas.toDataURL("image/jpeg");
  }

  return (
    <>
      <div className="is-screen text-center" >
        <canvas ref={myCanvas} id="my-canvas" width="600" height="278"></canvas>
        <h2 className="pb-4" style={{ fontSize: "1.2rem" }}>{curBoxSize.box_size}</h2>        
      </div>
    </>
  );

  /*

  const [canvasStyle, setCanvasStyle] = useState({ "padding": "20%" });
  // Ref for the canvas element
  const controlWrapper = useRef();

  const transformImage = () => {
    let posx = controlWrapper.current.offsetLeft + (controlWrapper.current.clientWidth * 0.25);
    let posy = controlWrapper.current.offsetTop + (controlWrapper.current.clientHeight * 0.15);
    let w = controlWrapper.current.clientWidth * 0.5;
    let h = controlWrapper.current.clientHeight * 0.7;

    if (session.pid != 144661) {
      //setCanvasStyle({ "position": "absolute", "top": `${posy}px`, "left": `${posx}px`, "width": `${w}px`, "height": `${h}px` });
    }
    else {
      //setCanvasStyle({ "position": "absolute", "top": `${posy}px`, "left": `${posx}px`, "width": `${w}px`, "height": `${h}px` });
    }
  }

  useEffect(() => {
    window.addEventListener("resize", (ev) => {
      if (controlWrapper.current) {
        // Trigger a transform within 10% proximity of breakpoints
        const screenWidth = ev.target.innerWidth;
        if (previewSettings && previewSettings.responsive) {
          previewSettings.responsive.map((item) => {
            const low = item.breakPoint - (item.breakPoint * 0.2);
            const high = item.breakPoint + (item.breakPoint * 0.2);
            if (screenWidth > low && screenWidth < high) {
              transformImage();
            }
          });
        }
        else {
          transformImage();
        }
      }
    });
  }, []);

  useEffect(() => {
    transformImage();
  }, [session.pid, croppedImage]);

  return (
    <div className="row my-2 justify-content-center">
      <div ref={controlWrapper} style={{ width: "600px", minWidth: "600px", height: "278px" }}>
        <img src={`dist/img/products/${session.pid}.jpg`} className="img-fluid" />
        <div style={canvasStyle} className="">
          <img src="/sees/dist/img/products/sample.jpg" className="img-fluid" />
        </div>
      </div>
    </div>
  )
  */
}

export default Preview;